module.exports = __webpack_public_path__ + "media/images/icon-reservation-167c7c111224090583f2ec4bd136b31e.svg";